module.exports = __webpack_public_path__ + "static/img/h7-2.bc7ecf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd112/h7-2.png
// module id = 7fZH
// module chunks = 1